export default {
  '500_title': 'هناك خطاء ما',
  '500_description':
    'هذه الصفحة توقفت بسبب خطاء فيها ومطورينا لديهم العلم الان بالخطاء ,وهم يعملون على اصلاحها باسرع وقت ممكن',
  '403_title': 'لا تملك صلاحية عرض هذه الصفحة',
  '403_description':
    ' لا يمكن الوصول لهذه الصفحة بحسب الصلاحيات الممنوحة لك، تواصل مع مشرف النظام لمزيد من المعلومات.',
  '404_title': 'صفحة غير موجودة',
  '404_description': 'عذرا, لاتوجد صفحة بهذا الرابط او انه قد تم تحويلة.',
}
